module.exports = __webpack_public_path__ + "img/Group 129.dba1183c.png";